import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { SmsGateEnum } from '@zaoblako/shared/modules/integration/enums/sms.gate.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link SmsGateEnum} enumeration values */
export const SmsGateEnumI18n: EnumI18nInterface<SmsGateEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [SmsGateEnum.MAIN_SMS]: 'MainSMS',
  },
  [I18nLocalesEnum.EN_US]: {
    [SmsGateEnum.MAIN_SMS]: 'MainSMS',
  },
};
